import React from "react";
import { ReadingProgress } from "@makotot/ghostui";
import sanityClient from "../client";

class ConsentToRecordTermsAndConditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
    };
  }

  handleApprovalClick = () => {
    this.props.handleApproval();
  };

  componentDidMount() {
    const query = `*[_type == "intakeFormSettings"]`;
    const params = {};

    sanityClient.fetch(query, params).then((intakeFormSettings) => {
      console.log("intakeFormSettings:");
      intakeFormSettings.forEach((settings) => {
        console.log(`${settings._id} (${settings.originalStatement})`);
        this.setState({ text: settings.consentToRecordTermsAndConditions });
      });
    });
  }

  render() {
    return (
      <div>
        <ReadingProgress>
          {({ value }) => (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                padding: "1rem",
              }}
            >
              {value ? (
                <progress
                  id="reading-progress"
                  className="progress is-info is-small"
                  value={value}
                  max={100}
                  style={{
                    width: "100%",
                  }}
                />
              ) : (
                <span></span>
              )}
            </div>
          )}
        </ReadingProgress>
        <div className="column is-two-thirds">
          <div>{this.state.text}</div>
          <button
            onClick={this.handleApprovalClick}
            className="button is-primary"
          >
            I acknowledge the terms of this agreement
          </button>
        </div>
      </div>
    );
  }
}

export default ConsentToRecordTermsAndConditions;
